import { request } from "./http/http_request";
import { setRefreshToken, setAccessToken, setIdUserInSession } from "./http/auth";
export function getTokens(instance, code, state, client_id, client_secret) {
  var data = {
    grant_type: "code",
    code: code,
    state: state,
    client_id: client_id,
    client_secret: client_secret
  };
  return request("/v1/gate/token", "post", data, false, "cap").then(function (response) {
    if (response.data.state == state) {
      setRefreshToken(response.data.refresh_token);
      setAccessToken(response.data.access_token);
      setIdUserInSession();
    } else {
      // TODO gérer mieux que ça cette erreur de state différent
      instance.$toasted.show(instance.errorMessages.state.different, {
        type: "error"
      });
      instance.stateError = instance.errorMessages.state.different;
    }
  });
}